/**
 * Created by Victor Rojo on 8/9/17.
 */
import { Injectable, Optional }     from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

import "file-saver";

import { iPlace, iPlaceDashboard } from "../model/iPlace";

@Injectable()
export class IPlaceService{

  private basePath = "api/v1/iplace/";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any, windowReference: any): Promise<any> {
    console.log('An error occurred', error);
    if (windowReference != null) windowReference.close();
    return Promise.reject(error.message || error);
  }

  private successHandler(response:string, uuid: string, windowReference: any): any{
    var result = response.split("\n")[1].split(">")[0].split("type=\"")[1];
    if ( result.startsWith("Success") ){
      let domainSegments = window.location.host.split(".");
      let target = window.location.host;
      if ( domainSegments.length > 3) {
        target = domainSegments.slice(1).slice(-3).join(".");
      }
      windowReference.location = "https://" + uuid + "." + target;
    } else {
      return Promise.reject(response);
    }
    return response;
  }

  get(): Promise<any>{
    let url = this.basePath;
    return this.http.get(url)
      .toPromise()
      .then( res => res as iPlace[])
      .catch( error => this.errorHandler(error, null) );
  }

  getDashboard(): Promise<any>{
    let url = this.basePath + "dashboard";
    return this.http.get(url)
      .toPromise()
      .then( res => res as iPlaceDashboard)
      .catch( error => this.errorHandler(error, null) );
  }

  localLogin(uuid: string): Promise<any> {
    let url = "api/v1/local/" + uuid + "/login";
    var windowReference = window.open("","_blank");
    return this.http
      .post(url, null, {responseType: 'text'})
      .toPromise()
      .then( response => this.successHandler(response, uuid, windowReference) )
      .catch(error => this.errorHandler(error, windowReference));
  }

  getLicenseFile(uuid: string): Promise<any> {
    let url = "api/v1/iplace_license/file/" + uuid;
    return this.http
      .get(url, {responseType: 'blob'})
      .toPromise()
      .then( response => {
        let FileSaver = require('file-saver');
        if ( FileSaver.saveAs ) {
          FileSaver.saveAs(response, "iplace.lic");
        } else{
          FileSaver(response, "iplace.lic");
        }
      } )
      .catch(error => {
        return new Promise((resolve, reject) => {
          var fr = new FileReader();
          fr.onload = function() {
            var obj = JSON.parse(error);
            reject(obj);
          };
          fr.readAsText(error.error);
        });
      });
  }
}
